export class NotInitializedError extends Error {
}
